var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragraph-struct"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.paragraphText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }